import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import stringHelper from '../../../../Helpers/stringHelper';
import SurveyService from '../../../../Services/surveyService';
import ErrorMessage from '../../../ErrorMessage';

export default class SurveySelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    idFilter: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.idFilter !== prevProps.idFilter) {
      this.populateListData();
    }
  }

  populateListData() {
    if (!this.props.idFilter) {
      this.setState({ selectValues: [] });
      return;
    }

    SurveyService.GetSurveyList(-1, this.props.idFilter)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .forEach((survey, index) => {
            optValues.push({
              label: survey.name + stringHelper.toBracket(survey.sassieId),
              value: `${survey.surveyId}//${survey.clientId}`,
              disabled: false,
            });
          });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('SUS57');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
